import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center" role="status" aria-label="Loading">
      <span className="h-10 w-10 animate-spin rounded-full border-4 border-[#027100]/20 border-t-[#027100]" />
    </div>
  );
};

export default Loader;
